import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import CustomButton from "../Components/Base/CustomButton";
import InputTextBox from "../Components/Base/InputTextBox";
import Loader from "../Components/Loder";
import ToolBar from "../Components/ToolBar/ToolBar";
import AppContext from "../Context/AppContext";
import { ReportBean } from "../Ds/client_ds";
import PageBar from "../Components/ToolBar/PageBar";
import DatePicker from"./../Components/Base/DatePicker";
 
import {
  InvoiceSearchCriteria,
  RestEntityPrintRequest,
  RestReadRequest,
  PageListBean,
  RestInvoiceListRequest,
  CustomerSearchCriteria,
  RestCustomerListRequest,
} from "../Ds/ds";
import service from "../Services/Service";
import {
  TOAST_ERROR,
  TOAST_SUCESS,
  TOAST_WARN,
} from "../Utils/appConstants";
import {
  ColumnDefinition,
  isEmpty,
  isEmptyArray,
  isEmptyString,
  StatusConvertor,
} from "../Utils/util";
import InValidAccess from "../Components/InValidAccess";
import { SecurityAccessManager } from "../Security/SecurityAccessManager";
import { EXCELICON, MOREOPTIONICON, PDFICON } from "../Utils/icons";
import Modal from "../Components/Modal";
import CustomTable from "../Components/Base/CustomTable";
import ViewToggle from "../Components/ViewToggle";
import MobileCardTable from "./../Components/MobileCardTable";


// ─────────────────────────────────────────────────────────────────────
// Invoice line detail modal content
// ─────────────────────────────────────────────────────────────────────
const InvoiceDetails = ({ receiptData: invoiceData }) => {
  const Columns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Item", "fabricStyleCode", true)
        .setStyleDetails("left", "7", "", "wt-5", "")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "7", "", "wt-5", "")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "4", "", "wt-5", "")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("OpenQty", "onOrderQuantity", true, true)
        .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("ShipQty", "shippedQuantity", true, true)
        .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("AdjQty", "returnQuantity", true, true)
        .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("cost", "cost", true, true)
        .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Disc", "lineDiscountAmount", true, true)
        .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("LineAmt", "lineTotalAmount", true, true)
        .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("LineNetAmt", "lineNetAmount", true)
        .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    );
    return _columns;
  };

  return (
    <div className="model-fw">
      <CustomTable columns={Columns} data={invoiceData.lines} />
    </div>
  );
};


// ─────────────────────────────────────────────────────────────────────
// Main component
// ─────────────────────────────────────────────────────────────────────
export default function InvoiceMaintenance() {
  const { token, setisSessionExpeired, session } = useContext(AppContext);
  const [dataList, setDataList] = useState([]);
  const [criteria, setCriteria] = useState(new InvoiceSearchCriteria());

  const title = "Invoices";

  // ── Filter state ──
  const [customerCode, setCustomerCode]   = useState("");

  const [page, setPage]               = useState(1);
  const [pageSize]                    = useState(50);
  const [maxPage, setMaxPage]         = useState(1);
  const [totalCount, setTotalCount]   = useState(0);
  const [isLoading, setIsLoading]     = useState(false);
  const [isShowPdf, setIsShowPdf]     = useState(false);
  const [isShowExcel, setIsShowExcel] = useState(false);
  const [disable, setDisable]         = useState(false);
  const [isAccessible, setIsAccessible] = useState(false);
  const [isShowModal, setIsShowModal]   = useState(false);
  const [receiptData, setInvoiceData]   = useState({});
  const [view, setView]               = useState(1); // 1 = list, 2 = grid

  // ── Mobile filter sheet ──
  const [isMobile, setIsMobile]         = useState(window.innerWidth <= 768);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const isEntityUser = !isEmptyString(session?.entityCode);

 

  const inputRef    = useRef(null);
  const buttonRef   = useRef(null);
  const criteriaRef = useRef(null);


    // ── Customer lookup state ──────────────────────────────────────────────────
  const customerCodeRef                                       = useRef(null);
  // Replaced external CustomerLookupHandler with inline CustomerLookupModal
  const [isCustomerLookupOpen, setIsCustomerLookupOpen]       = useState(false);
  const [customerPageListForAutoCompleteList, setCustomerPageListForAutoCompleteList] = useState([]);
  // Start as false — the dropdown must be hidden until the user actually types
  const [showAutoCompleteCustomerList, setShowAutoCompleteCustomerList] = useState(false);
  const [isCustomerNotFound, setIsCustomerNotFound]           = useState(false);
  // Stores the customer description returned by readCustomerWithChildren so
  // addSalesLine can set listRequest.customerName without a second service call.
  const [customerName, setCustomerName]                       = useState("");

  // ── Lifecycle ──
  useEffect(() => {
    setFocus();
    asignDefault();
    loadPage(1);
  }, []);

  useEffect(() => {
    function handleResize() {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Only auto-switch view on resize; let the manual toggle
      // (listViewHandler / gridViewHandler) win otherwise.
      setView((prevView) => (mobile ? 2 : prevView === 2 ? 1 : prevView));
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ── Helpers ──
  const setFocus = () => { if (inputRef.current) inputRef.current.focus(); };

  const notify = (type, msg, theme) => {
    if (type === 1) toast.info(msg, { theme });
    else if (type === 2) toast.error(msg, { theme });
    else if (type === 3) toast.success(msg, { theme });
    else if (type === 4) toast.warn(msg, { theme });
    else toast(msg);
  };

  const errorCallBack = (error) => {
    setIsLoading(false);
    notify(TOAST_ERROR, error.message);
  };

  const asignDefault = () => {
    const _criteria = new InvoiceSearchCriteria();
    _criteria.companyCode = process.env.REACT_APP_COMPANY;
    if (!isEmpty(session)) {
      const { entityCode } = session;
      if (!isEmptyString(entityCode)) {
        _criteria.customerCode = entityCode;
        setCustomerCode(entityCode);
      }
    }
    criteriaRef.current = _criteria;
    setCriteria(_criteria);
  };

  
const onCriteriaChange = (e) => {
  const { name, value } = e.target;

  const updated = {
    ...criteriaRef.current, // ✅ correct source
    [name]: value,
  };

  criteriaRef.current = updated;
  setCriteria(updated);
};

  // ── Response handlers ──
  const handleInvoiceDetailsResponse = (response) => {
    let msg_List = [];
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (!isEmpty(response.data.invoice)) {
          setInvoiceData(response.data.invoice);
          setIsShowModal(true);
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => msg_List.push(info.messageDescription));
          notify(TOAST_SUCESS, msg_List.toString());
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => msg_List.push(error.messageDescription));
          notify(TOAST_ERROR, msg_List.toString());
        }
      }
    }
    setIsLoading(false);
  };

  const handleReportResponse = (response) => {
    let msg_List = [];
    if (response.data != null) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (response.data.reportResult != null) {
          if (!isEmptyString(response.data.reportResult.reportFileID)) {
            window.open(
              `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_REPORT_PATH}` +
                response.data.reportResult.reportFileID
            );
          }
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => msg_List.push(info.messageDescription));
          notify(TOAST_SUCESS, msg_List.toString());
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => msg_List.push(error.messageDescription));
          notify(TOAST_ERROR, msg_List.toString());
        }
      }
    }
    setIsLoading(false);
  };

  const handleResponse = (response) => {
    let msg_List = [];
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.invoicePageList) &&
          !isEmptyArray(response.data.invoicePageList.invoices)
        ) {
          setDataList(response.data.invoicePageList.invoices);
          if (response.data.invoicePageList.totalCount != null) {
            const total_Count = response.data.invoicePageList.totalCount;
            setTotalCount(total_Count);
            setMaxPage(Math.ceil(total_Count / pageSize));
          }
          if (response.data.invoicePageList.currentPage != null) {
            setPage(response.data.invoicePageList.currentPage);
          }
          if (!isEmptyArray(response.data.infos)) {
            response.data.infos.map((info) => msg_List.push(info.messageDescription));
          }
        }
        if (
          !isEmpty(response.data.invoicePageList) &&
          isEmptyArray(response.data.invoicePageList.invoices)
        ) {
          notify(TOAST_WARN, "No Data Found");
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => msg_List.push(error.messageDescription));
          notify(TOAST_ERROR, msg_List.toString());
        }
      }
    }
    setIsLoading(false);
  };

  // ── API calls ──
  const loadPage = (id) => {
    setDataList([]);
    setIsLoading(true);
    const request = new RestInvoiceListRequest();
    request.searchCriteria = criteriaRef.current;
    const pageInput = new PageListBean();
    pageInput.currentPage = id;
    pageInput.pageSize = pageSize;
    request.pageInput = pageInput;
    service(token, "getInvoicePageList", request, handleResponse, errorCallBack);
  };

  const generateReport = (type, code) => {
    const request = new RestEntityPrintRequest();
    const reportBean = new ReportBean();
    reportBean.reportType = type;
    request.companyCode = process.env.REACT_APP_COMPANY;
    request.entityCode = code;
    request.reportBean = reportBean;
    service(token, "generateInvoicePrintReport", request, handleReportResponse, errorCallBack);
  };

  const getInvoiceDetails = (code) => {
    setIsLoading(true);
    const request = new RestReadRequest();
    request.companyCode = process.env.REACT_APP_COMPANY;
    request.code = code;
    service(token, "readInvoice", request, handleInvoiceDetailsResponse, errorCallBack);
  };

  // ── Button handlers ──
  const ExecuteHandler = () => {
    // buildCriteria();
    setTimeout(() => loadPage(1), 0);
  };

  const buttonHandler = () => ExecuteHandler();
  const loadFirst    = () => loadPage(1);
  const loadLast     = () => loadPage(maxPage);
  const loadPrevious = () => { if (page > 1) loadPage(parseInt(page) - 1); };
  const loadNext     = () => { if (maxPage > page) loadPage(parseInt(page) + 1); };

  const PDFHandler = (code) => {
    if (SecurityAccessManager.InvoiceMaintenancePDFReport_IsAccessible()) {
      setIsLoading(true);
      generateReport(1, code);
    } else { setIsAccessible(true); }
  };

  const ExcelHandler = (code) => {
    if (SecurityAccessManager.InvoiceMaintenanceExcelReport_IsAccessible()) {
      setIsLoading(true);
      generateReport(2, code);
    } else { setIsAccessible(true); }
  };

  const MoreOptionHandler = (code) => getInvoiceDetails(code);
  const openModal         = (code) => getInvoiceDetails(code);
  const closeModal        = () => setIsShowModal(false);
  const onClose           = () => setIsAccessible(false);

  const ResetHandler = () => {
    setDataList([]);
    setDisable(false);
    setIsShowExcel(false);
    setIsShowPdf(false);
    setCustomerCode("");
    // setGeneralSearch("");
    // setFromDate("");
    // setToDate("");
    // setStatus("");
    setFocus();
    asignDefault();
  };

  const listViewHandler = () => setView(1);
  const gridViewHandler = () => setView(2);

  const getCaption = (s) => StatusConvertor("1", s);

  // ── Table columns ──
  const Columns = () => {
    const _columns = new Array();
    _columns.push(new ColumnDefinition().setDetails("Inv#", "code", true).setStyleDetails("left", "", "", "wt-4", "wt-4"));
    _columns.push(new ColumnDefinition().setDetails("S.O#", "salesOrderNumber", true).setStyleDetails("left", "", "", "wt-4", "wt-4"));
    _columns.push(new ColumnDefinition().setDetails("Status", "invoiceStatus", true).setStyleDetails("left", "", "", "wt-3", "wt-3").setStatusDetails(true, getCaption));
    _columns.push(new ColumnDefinition().setDetails("Customer", "customerCode", true).setStyleDetails("left", "10", "", "wt-3", "wt-3"));
    _columns.push(new ColumnDefinition().setDetails("Name", "customerName", true).setStyleDetails("left", "10", "", "wt-3", "wt-3"));
    _columns.push(new ColumnDefinition().setDetails("InvoiceDate", "invoiceDate", true, false, true).setStyleDetails("left", "10", "", "wt-3", "wt-3"));
     _columns.push(new ColumnDefinition().setDetails("DueDate", "invoiceDate", true, false, true).setStyleDetails("left", "10", "", "wt-3", "wt-3"));
    _columns.push(new ColumnDefinition().setDetails("", "code", true).setStyleDetails("right", "", "", "wt-3", "wt-3").setClickDetails(false, true, PDFHandler, <PDFICON />));
    _columns.push(new ColumnDefinition().setDetails("", "code", true).setStyleDetails("right", "", "", "wt-3", "wt-3").setClickDetails(false, true, MoreOptionHandler, <MOREOPTIONICON />));
    return _columns;
  };

  // ── Status pill options ──
  const statusOptions = [
    { value: "",          label: "All" },
    { value: "A",      label: "Approved" },
    { value: "U",      label: "UnApproved" },
    { value: "F",   label: "Paid" },
    { value: "P", label: "Partially Paid" },
     { value: "X", label: "Cancelled" },
  ];




  
      // ── Customer lookup handlers ───────────────────────────────────────────────
    const onCustomerCodeChange = (e) => {
      const customerCode = e.target.value.toUpperCase();
      if (!customerCode) {
        // Field cleared — hide dropdown, reset not-found flag, clear order session
        setShowAutoCompleteCustomerList(false);
        setCustomerPageListForAutoCompleteList([]);
        setIsCustomerNotFound(false);
        setCustomerName("");
        // currentCustomerOrderRef.current = null;
        // lastHeaderKeyRef.current = null;
      } else {
        // Characters typed — show dropdown and kick off the search-as-you-type call
        setShowAutoCompleteCustomerList(true);
        readCustomerBySearchString(e.target.value);
        // Reset order session whenever the customer code changes
        // currentCustomerOrderRef.current = null;
        // lastHeaderKeyRef.current = null;
      }
      setCriteria((prev) => {
        const next = { ...prev, [e.target.name]: customerCode };
        criteriaRef.current = next;
        return next;
      });
    };
  
    const customerCodeEnterKeyEventHandler = (e) => {
      readCustomerByCode(e.target.value);
      setCustomerPageListForAutoCompleteList([]);
      setShowAutoCompleteCustomerList(false);
      // Advance focus to the next field in the sequence
     // enterKeyHandler("customerCode");
    };
  
    //   const enterKeyHandler = (fieldName) => {
      
    //   const currentIndex = FIELD_SEQUENCE.indexOf(fieldName);
      
    //   if (currentIndex === -1) return;
    //   const nextField = FIELD_SEQUENCE[currentIndex + 1];
    //   if (nextField) {
    //     focusRef(FIELD_REF_MAP[nextField]);
    //   }
    // };
  
    // Called when user picks a row inside CustomerLookupModal
    const onCustomerLookupSelect = (item) => {
      setCriteria((prev) => {
        const next = { ...prev, customerCode: item.code };
        criteriaRef.current = next;
        return next;
      });
      setIsCustomerNotFound(false);
      setCustomerPageListForAutoCompleteList([]);
      setShowAutoCompleteCustomerList(false);
      // currentCustomerOrderRef.current = null;
      // lastHeaderKeyRef.current        = null;
      // Validate/load the selected customer via readCustomerWithChildren
      readCustomerByCode(item.code);
    };
  
    const displayAutoCompleteCustomerList = (show) => {
      setShowAutoCompleteCustomerList(show);
    };
  
    const readCustomerBySearchString = (searchString) => {
      const searchCriteria = new CustomerSearchCriteria();
      searchCriteria.companyCode = process.env.REACT_APP_COMPANY;
      // Match by code prefix OR name — uppercase so the server index is hit correctly
      searchCriteria.customerCodeStartsWith = searchString.toUpperCase();
      searchCriteria.customerNameContains   = searchString;
      const pageInput = new RestCustomerListRequest();
      pageInput.pageInput          = new PageListBean();
      pageInput.pageInput.pageSize = 100;
      pageInput.searchCriteria     = searchCriteria;
      service(
        token,
        "getCustomerPageList",
        pageInput,
        (response) => {
          const customers = response?.data?.customerPageList?.customers || [];
          const list = customers
          //  .filter((c) => c.Status === "A")
          .filter((c) => c.Status === "A" || c.status === "A")
          .map((c) => ({ code: c.code, description: c.description }));
          setCustomerPageListForAutoCompleteList(list);
        },
        // Search-as-you-type errors should not flag the field as not-found —
        // that is only done by readCustomerByCode (triggered on Enter / selection).
        () => setCustomerPageListForAutoCompleteList([]),
      );
    };
  
    // readCustomerByCode — called on Enter in the Customer textbox.
    // Uses readCustomerWithChildren (mirrors readCustomer() in SalesOrderMaintenanceModule):
    //   • Builds a RestReadRequest with companyCode, code, isLoadChildren=true
    //   • Calls CustomerService.readCustomerWithChildren
    //   • On success: reads response.data.customer, sets isCustomerNotFound based on
    //     active status (matches readCustomerResponse in maintenance module)
    //   • On error: marks customer as not found
    const readCustomerByCode = (customerCode) => {
      if (!customerCode) return;
      const readRequest = new RestReadRequest();
      readRequest.companyCode   = process.env.REACT_APP_COMPANY;
      readRequest.code          = customerCode.toUpperCase();
      readRequest.isLoadChildren = true;
       service(token,"readCustomerWithChildren",readRequest,
        (response) => {
          const customerData = response?.data?.customer;
          if (customerData) {
            // Inactive customers are flagged as "not found" — mirrors readCustomerResponse
            const isInactive = customerData.isActive === false;
            setIsCustomerNotFound(isInactive);
            if (isInactive) {
              notify(TOAST_WARN, "Customer is InActive");
              setCustomerName("");
           
            } else {
              // Persist the name so addSalesLine can populate listRequest.customerName
              // setCustomerName(customerData.description || "");
              // setPaymentTerms(customerData.paymentTermsCode || "");
              // setPaymentMethodCode(customerData.paymentMethodCode || "");
              //  setCustomerTypeCode(customerData.customerTypeCode || "");
              // setCreatedBy(customerData.createdBy || "");
             
             setCustomerName(customerData);
  
            }
          } else {
            setIsCustomerNotFound(true);
            setCustomerName("");
  
  
          }
        },
        () => { setIsCustomerNotFound(true); setCustomerName(""); },
      );
    };


  // ─────────────────────────────────────────────────────────────────────
  // Render
  // ─────────────────────────────────────────────────────────────────────

  return (
    <>

    
      {isLoading ? <Loader /> : null}

      {/* ── Detail modal ── */}
      <Modal isOpen={isShowModal} onClose={closeModal} title="Invoice Lines">
        <InvoiceDetails receiptData={receiptData} />
      </Modal>

      {/* ── Toolbar ── */}
      <ToolBar
        title={title}
        ResetHandler={ResetHandler}
        ExecuteHandler={ExecuteHandler}
        isShowPdf={isShowPdf}
        isShowExcel={isShowExcel}
      />

  
      {!isMobile && (
        <div className="card-body">
          <div className="row" style={{ flexWrap: "wrap", gap: "8px", alignItems: "flex-end" }}>

            {/* Customer */}
            {!isEntityUser && (
              <div className="form-group" style={{ flex: "1 1 160px", minWidth: 0 }}>
                <InputTextBox
                  // label="Customer"
                  // name = {"customerCode"}
                  // value={criteria.customerCode}
                  // inputRef={inputRef}
                  // placeholder="Customer code"
              
                  //    onChange={(e) => onCriteriaChange(e)}
                                          onChange={onCustomerCodeChange}
                  ref={customerCodeRef}
                  name="customerCode"
                  placeholder="Customer"
                  value={criteria.customerCode}
                  enterKeyEventHandler={customerCodeEnterKeyEventHandler}
                  autoCompleteListData={customerPageListForAutoCompleteList}
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={displayAutoCompleteCustomerList}
                  showAutoCompleteList={showAutoCompleteCustomerList}
                  isMandatory={true}
                  isNotFound={isCustomerNotFound}
                  label="Customer"
                  inputRef={inputRef}
                  lookupList={customerPageListForAutoCompleteList}
                  showLookupDropdown={showAutoCompleteCustomerList && customerPageListForAutoCompleteList.length > 0}
                  onLookupSelect={(item) => onCustomerLookupSelect(item)}
                  onHideLookupDropdown={() => setShowAutoCompleteCustomerList(false)}
                    disable={disable}
                />
              </div>
            )}

            {/* General search */}
            <div className="form-group" style={{ flex: "2 1 200px", minWidth: 0 }}>
              <InputTextBox
                label="Search"
                  name = {"searchName"}
                value={criteria.searchName}
                placeholder="Invoice / S.O / name…"

                   onChange={(e) => onCriteriaChange(e)}
              />
            </div>

            {/* From date */}
            <div className="form-group" style={{ flex: "1 1 140px", minWidth: 0 }}>
              <DatePicker
                type="date"
                label="From"
                    name = {"invoiceFromDate"}
                value={criteria.invoiceFromDate}
            
                   onChange={(e) => onCriteriaChange(e)}
              />
            </div>

            {/* To date */}
            <div className="form-group" style={{ flex: "1 1 140px", minWidth: 0 }}>
              <DatePicker
                type="date"
                label="To"
                 name = {"invoiceToDate"}
                value={criteria.invoiceToDate}
           
                   onChange={(e) => onCriteriaChange(e)}
              />
            </div>

            {/* Status */}
            <div className="form-group" style={{ flex: "0 0 130px" }}>
              <label style={{
                fontSize: "12px", marginBottom: "4px", display: "block",
                color: "var(--color-text-secondary, #888)",
              }}>Status</label>
              <select
                value={criteria.invoiceStatus}
                     name = {"invoiceStatus"}
                   onChange={(e) => onCriteriaChange(e)}
                style={{
                  width: "100%", height: "36px", borderRadius: "6px",
                  border: "1px solid var(--color-border-tertiary, #3a2f70)",
                  background: "var(--color-background-primary, #1f1848)",
                  color: "var(--color-text-primary, #e0d7ff)",
                  padding: "0 8px", fontSize: "13px",
                }}
              >
                {statusOptions.map((o) => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>

            {/* Buttons */}
            <div className="form-group col-fit btn-group" style={{ flexShrink: 0 }}>
              <CustomButton buttonHandler={buttonHandler} disable={disable} buttonRef={buttonRef} label="Fetch" />
              <CustomButton buttonHandler={ResetHandler} label="Reset" />
            </div>

          </div>
        </div>
      )}

    
      {isMobile && (
        <div className="module-filter-mobile mobile-filter-bar">
          <button className="mobile-filter-pill" onClick={() => setIsFilterOpen(true)}>
            <svg width="13" height="13" viewBox="0 0 16 16" fill="none"
              stroke="currentColor" strokeWidth="2.2">
              <line x1="2" y1="4" x2="14" y2="4" />
              <line x1="4" y1="8" x2="12" y2="8" />
              <line x1="6" y1="12" x2="10" y2="12" />
            </svg>
            Filters
          
          </button>
          <div style={{ display: "flex", gap: "8px" }}>
            <button className="mobile-action-btn" onClick={buttonHandler}>Fetch</button>
            <button className="mobile-action-btn outline" onClick={ResetHandler}>Reset</button>
          </div>
        </div>
      )}


      {isMobile && (
        <div className="module-filter-mobile" style={{ flexDirection: "column", width: "100%" }}>


        
          {isFilterOpen && (
            <div className="mobile-filter-overlay" onClick={() => setIsFilterOpen(false)} />
          )}

    
          <div className={`mobile-filter-sheet${isFilterOpen ? " is-open" : ""}`}>
            <div className="mobile-sheet-handle" />

      
            <div className="mobile-sheet-header">
              <span className="mobile-sheet-title">Filters</span>
              <div className="mobile-sheet-header-actions">
                <button className="mobile-sheet-clear" onClick={() => {
                 asignDefault()
                }}>Clear all</button>
                <button className="mobile-sheet-close" onClick={() => setIsFilterOpen(false)}>×</button>
              </div>
            </div>

            {/* Filter inputs */}
            <div className="mobile-sheet-body">

              {/* Customer */}
              <div className="mobile-filter-row">
                    {!isEntityUser && (
                <span className="mobile-filter-label">Customer</span>
                    )}
                      {!isEntityUser && (
                <InputTextBox
                //  value={criteria.customerCode}
                //   name="customerCode"
                //   placeholder="Enter customer code"
                //   disable={isEntityUser}
                //      onChange={(e) => onCriteriaChange(e)}

                                     onChange={onCustomerCodeChange}
                  ref={customerCodeRef}
                  name="customerCode"
                  placeholder="Customer"
                  value={criteria.customerCode}
                  enterKeyEventHandler={customerCodeEnterKeyEventHandler}
                  autoCompleteListData={customerPageListForAutoCompleteList}
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={displayAutoCompleteCustomerList}
                  showAutoCompleteList={showAutoCompleteCustomerList}
                  isMandatory={true}
                  isNotFound={isCustomerNotFound}
                  label="Customer"
                  inputRef={inputRef}
                  lookupList={customerPageListForAutoCompleteList}
                  showLookupDropdown={showAutoCompleteCustomerList && customerPageListForAutoCompleteList.length > 0}
                  onLookupSelect={(item) => onCustomerLookupSelect(item)}
                  onHideLookupDropdown={() => setShowAutoCompleteCustomerList(false)}
                    disable={disable}
               
                />
                      )}
              </div>

           
              <div className="mobile-filter-row">
                <span className="mobile-filter-label">Search</span>
                <InputTextBox
                name = {"searchName"}
                value={criteria.searchName}
                  placeholder="Invoice / S.O / name…"
              
                    onChange={(e) => onCriteriaChange(e)}
                />
              </div>

          
              <div className="mobile-filter-row">
                <span className="mobile-filter-label">Date Range</span>
                <div className="mobile-date-grid">
                  <DatePicker
                    type="date"
                    label="From"
                    name = {"invoiceFromDate"}
                value={criteria.invoiceFromDate}
                 
                      onChange={(e) => onCriteriaChange(e)}
                  />
                  <DatePicker
                    type="date"
                    label="To"
                   name = {"invoiceToDate"}
                value={criteria.invoiceToDate}
                       onChange={(e) => onCriteriaChange(e)}
                  />
                </div>
              </div>

         
              <div className="mobile-filter-row">
                <span className="mobile-filter-label">Status</span>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {statusOptions.map((o) => (
  <button
    key={o.value}
    className={`mobile-status-pill${criteria.invoiceStatus === o.value ? " active" : ""}`}
    onClick={() =>
      onCriteriaChange({
        target: {
          name: "orderStatus",
          value: o.value,
        },
      })
    }
  >
    {o.label}
  </button>
))}
                </div>
              </div>

            </div>

            <button className="mobile-sheet-apply" onClick={() => {
              setIsFilterOpen(false);
            
              setTimeout(() => loadPage(1), 0);
            }}>
              Apply Filters
            </button>
          </div>

        </div>
      )}

      {/* ── Pagination ── */}
      {!isEmptyArray(dataList) && (
        <PageBar
          loadFirst={loadFirst}
          loadNext={loadNext}
          loadPrevious={loadPrevious}
          loadLast={loadLast}
          page={page}
        />
      )}

      {/* ── View toggle ── */}
      {!isEmptyArray(dataList) && (
        <ViewToggle
          listViewHandler={listViewHandler}
          gridViewHandler={gridViewHandler}
        />
      )}

      {/* ── Results table / card list ── */}
      {!isEmptyArray(dataList) && (
        <div className="card-body">
          <div className="card-title">
            <h1>Invoice Details</h1>
          </div>
          <div className="list-wrap">
            {view === 1 ? (
              <CustomTable
                columns={Columns}
                data={dataList}
                isShowFullScreen={true}
              />
            ) : (
             <MobileCardTable
                columns={Columns()}
                data={dataList}
                codeAccessor="code"
                // subAccessor="customerName"
                // dateAccessor="createdDate"
                // statusAccessor="orderStatus"
                onPDF={(row) => PDFHandler(row.code)}
                onMoreOption={(row) => MoreOptionHandler(row.code)}
              />
            )}
          </div>
        </div>
      )}

      <InValidAccess isShow={isAccessible} clickHandler={onClose} />
    </>
  );
}